import { createContext } from "react";
import { FilterContextState } from "./filterContext.types";

const defaultState: FilterContextState = {
  isXsScreen: false,
};

export const FilterContext = createContext<FilterContextState>(defaultState);
